const Awards = () => (
  <div className="tab-contents" id="awards">
    <ul>
      <li>
        <span>2020</span>
        <br />
        I have been selected as the top student in my baccalaureate exams for the Casablanca region in Morocco.{" "}
      </li>
      <li>
        <span>2022</span>
        <br />
        Dean's List at Al Akhawayn University in Morocco.
      </li>
      <li>
        <span>2023</span>
        <br />
        Honor List at Agnes Scott College in USA.
      </li>
    </ul>
  </div>
);

export default Awards;
